import SimpleStore from './simpleStore';
import DefaultPlugins, { compatiblePluginAlias, mergePlugins } from './plugins';
import './index.css';

const BottomSheet = function (qs, options) {
  if (!qs) throw 'No Element';
  if (!(window && window.document && window.document instanceof Document)) {
    throw 'Bottom Sheet Use Only Web Browser';
  }

  this.options = options || {};
  this.func = BottomSheet.func;
  this.store = new SimpleStore();
  this.pluginData = {};

  this.originEl = this.func.getOriginEl(qs);
  this.init();
  this.initCustomStyleClass();
  this.generate();
  this.initActions();
  this.initPlugins();
  this.addEvents();
  this.clear();
  this.emitEvent('xe_bottomsheet::init');
};

BottomSheet.prototype.initActions = function () {
  const setting = this.setting;
  this.store.addAction('open', function (store, data) {
    store.set('isOpen', true);
  });
  this.store.addAction('close', function (store, data) {
    store.set('isOpen', false);
  });

  this.store.addAction(
    'expend',
    function (store, data) {
      let pos;
      if (setting.expendPos) {
        pos = setting.expendPos;
      } else if (window.innerHeight * 0.9 < this.wrapper.clientHeight) {
        pos = window.innerHeight * 0.1;
      } else {
        pos = window.innerHeight - this.wrapper.clientHeight;
      }

      if (setting.bodyScroll) {
        pos += document.body.scrollTop;
      } else if (setting.documentScroll) {
        pos += document.documentElement.scrollTop;
      } else {
        pos += this.container.scrollTop;
      }

      store.set('pos', pos);
      this.wrapper.style.top = pos + 'px';

      store.set('isOpen', true);
      store.set('isExpend', true);
    }.bind(this)
  );
};

BottomSheet.prototype.initPlugins = function () {
  this.setting.plugins.forEach((pname) => {
    const plugin = BottomSheet.plugins[pname];
    if (plugin && typeof plugin.init === 'function') {
      plugin.init(this);
    } else {
      console.error(`Not Found Plugin "${pname}" by BottomSheet.js`);
    }
  });
};

BottomSheet.prototype.destroyPlugins = function () {
  this.setting.plugins.forEach((pname) => {
    const plugin = BottomSheet.plugins[pname];
    if (plugin && typeof plugin.destroy === 'function') {
      plugin.destroy(this);
    } else {
      console.error(`Not Found Plugin "${pname}" by BottomSheet.js`);
    }
  });
};

BottomSheet.prototype.addEvents = function () {
  const store = this.store;
  store.set('isMoveStart', false);
  const wrapper = this.wrapper;
  const setting = this.setting;
  const container = this.container;

  let nowPos = 0;

  if (setting.contentsClickOpen) {
    this.contents.addEventListener('click', (ev) => {
      if (store.get('isOpen')) return;
      ev.preventDefault();
      ev.stopPropagation();
      this.openSheet();
    });
  }
  if (setting.closeBlockScroll) {
    this.contents.addEventListener('scroll', (ev) => {
      if (store.get('isOpen')) return;
      ev.preventDefault();
      ev.stopPropagation();
    });

    this.contents.addEventListener('touchmove', (ev) => {
      if (store.get('isOpen')) return;
      ev.preventDefault();
      ev.stopPropagation();
    });
  }

  if (setting.useHandle) {
    this.handle.addEventListener('touchstart', (ev) => {
      wrapper.style.transition = 'none';
      this.handle.classList.add('__xeBottomSheetHandle--grap');

      store.set('isMoveStart', true);
      store.set('touchStartPos', ev.touches[0].clientY);

      if (setting.bodyScroll) {
        document.body.style.overflow = 'hidden';
      } else if (setting.documentScroll) {
        document.documentElement.style.overflow = 'hidden';
      } else {
        container.style.overflow = 'hidden';
      }
    });

    this.handle.addEventListener('touchmove', (ev) => {
      if (!store.get('isMoveStart')) return;
      if (ev.cancelable) ev.preventDefault();
      ev.stopPropagation();
      store.set('isMoving', true);
      nowPos = ev.touches[0].clientY;

      wrapper.style.bottom = 'auto';

      if (setting.bodyScroll) {
        wrapper.style.top = (nowPos + document.body.scrollTop) + 'px';
      } else if (setting.documentScroll) {
        wrapper.style.top = (nowPos + document.documentElement.scrollTop) + 'px';
      } else {
        wrapper.style.top = (nowPos + container.scrollTop) + 'px';
      }
    });

    this.handle.addEventListener('touchend', () => {
      wrapper.style.transition = `top ${setting.transitionTimeout}ms`;
      this.handle.classList.remove('__xeBottomSheetHandle--grap');

      const startPos = store.get('touchStartPos') || 0;
      const distance = startPos - nowPos;
      if (distance > 30) {
        this.openSheet();
      } else if (distance < -30) {
        this.closeSheet();
      } else {
        this.toggleSheet();
      }

      store.set('isMoving', false);
      store.set('isMoveStart', false);
      if (!store.get('isOpen')) {
        if (setting.bodyScroll) {
          document.body.style.overflow = '';
        } else if (setting.documentScroll) {
          document.documentElement.style.overflow = '';
        } else {
          container.style.overflow = '';
        }
      }
    });

    this.handle.addEventListener('click', (ev) => {
      ev.preventDefault();
      ev.stopPropagation();
      if(ev.pointerType !== 'touch') {
        this.toggleSheet();
      }
    });
  }
  if (setting.useCover) {
    this.cover.addEventListener('touchmove', (ev) => { }, { passive: true });
    this.cover.addEventListener('click', (ev) => {
      ev.preventDefault();
      ev.stopPropagation();
      this.closeSheet();
    });
  }
};

BottomSheet.prototype.init = function () {
  const setValue = BottomSheet.utils.setValue;
  const options = this.options;
  this.setting = {
    container: setValue(options, 'container', undefined),
    useHandle: setValue(options, 'useHandle', true),
    useCover: setValue(options, 'useCover', true),
    initPos: setValue(options, 'initPos', 0),
    openPos: setValue(options, 'openPos', false),
    expendPos: setValue(options, 'expendPos', false),
    closeBlockScroll: setValue(options, 'closeBlockScroll', false),
    contentsClickOpen: setValue(options, 'contentsClickOpen', false),
    transitionTimeout: setValue(options, 'transitionTimeout', 500),
    bodyScroll: setValue(options, 'bodyScroll', false),
    documentScroll: setValue(options, 'documentScroll', false),
    plugins: setValue(options, 'plugins', []),
  };

  this.container = window.document.body;
  if (this.setting.container instanceof HTMLElement) {
    this.container = this.setting.container;
  }
  if (typeof this.setting.container === 'string') {
    this.container = window.document.querySelector(this.setting.container);
  }

  const store = this.store;
  store.set('isOpen', setValue(options, 'isOpen', false));
  store.set('isExpend', setValue(options, 'isExpend', false));
  store.set('isCover', setValue(options, 'isCover', false));
  store.set('pos', 0);
  store.set('height', 0);

  this.originEl.dataset['xeBottomSheetInstanceId'] = Math.random().toString(16).slice(2);

  BottomSheet.instances.set(this.originEl.dataset['xeBottomSheetInstanceId'], this);
};

BottomSheet.prototype.generate = function () {
  const setting = this.setting;
  const isDiffContainerBody = this.container !== window.document.body;

  this.wrapper = this.func.createWrapper(isDiffContainerBody, this.options.customStyleClass.wrapper);
  this.contents = this.func.createContents(this.options.customStyleClass.contents);

  if (setting.useHandle) {
    this.handle = this.func.createHandle(this.options.customStyleClass.handle);
    this.wrapper.appendChild(this.handle);
  }

  this.originElParent = this.originEl.parentElement;
  this.originElParent.removeChild(this.originEl);
  this.contents.appendChild(this.originEl);

  this.wrapper.appendChild(this.contents);

  if (setting.useCover) {
    this.cover = this.func.createCover(isDiffContainerBody, this.options.customStyleClass.cover);
    this.container.appendChild(this.cover);
  }

  this.container.appendChild(this.wrapper);

  let resizeCnt = 0;
  window.addEventListener('resize', () => {
    resizeCnt++;
    setTimeout(() => {
      if (--resizeCnt === 0 && this.store.get('isOpen')) this.openSheet();
    }, 300);
  });
};

BottomSheet.prototype.clear = function () {
  if (this.store.get('isOpen')) {
    this.openSheet(true);
  } else {
    this.closeSheet(true);
  }

  this.wrapper.style.transition = `top ${this.setting.transitionTimeout}ms`;
};

BottomSheet.prototype.closeSheet = function (pass) {
  if (pass || this.store.get('isOpen')) {
    this.emitEvent('xe_bottomsheet::close');
  }

  if (this.setting.closeBlockScroll) {
    if (this.setting.bodyScroll) {
      document.body.style.overflow = 'hidden';
    } else if (this.setting.documentScroll) {
      document.documentElement.style.overflow = 'hidden';
    } else {
      this.container.style.overflow = 'hidden';
    }
  } else {
    if (this.setting.bodyScroll) {
      document.body.style.overflow = '';
    } else if (this.setting.documentScroll) {
      document.documentElement.style.overflow = '';
    } else {
      this.container.style.overflow = '';
    }
  }

  let pos = this.setting.initPos;
  if (this.setting.bodyScroll) {
    pos -= document.body.scrollTop;
  } else if (this.setting.documentScroll) {
    pos -= document.documentElement.scrollTop;
  }

  this.store.set('pos', pos);
  this.wrapper.style.top = `calc(100% - ${pos}px)`;
  
  if (this.setting.useCover) {
    this.cover.classList.remove('__xeBottomSheetCover--open');
    this.cover.style.top = '';
  }

  this.closeTimeout = setTimeout(() => {
    this.wrapper.classList.remove('__xeBottomSheetWrapper--open');
    this.wrapper.style.bottom = '';
  }, this.setting.transitionTimeout);

  if (pass || this.store.get('isOpen')) {
    this.container.style.overflow = '';
    this.store.execAction('close');
    this.emitEvent('xe_bottomsheet::close_done');
  }
};

BottomSheet.prototype.close = function () {
  this.closeSheet();
};

BottomSheet.prototype.openSheet = function (pass) {
  if (pass || !this.store.get('isOpen')) {
    this.emitEvent('xe_bottomsheet::open');

    this.wrapper.style.transition = 'none';
    // let initialPos = window.innerHeight;
    // if (this.setting.bodyScroll) {
    //   initialPos += document.body.scrollTop;
    // } else if (this.setting.documentScroll) {
    //   initialPos += document.documentElement.scrollTop;
    // } else {
    //   initialPos += this.container.scrollTop;
    // }
    // this.wrapper.style.top = `${initialPos}px`;
  }

  if (this.closeTimeout) {
    clearTimeout(this.closeTimeout);
  }

  if (this.setting.closeBlockScroll) {
    this.contents.style.overflow = '';
  }

  this.wrapper.style.bottom = 'auto';

  let pos = window.innerHeight - (this.setting.openPos || 0);
  if (!this.setting.openPos) {
    pos = window.innerHeight * 0.9 < this.wrapper.clientHeight ? window.innerHeight * 0.1 : window.innerHeight - this.wrapper.clientHeight;
  }

  if (this.setting.bodyScroll) {
    pos += document.body.scrollTop;
  } else if (this.setting.documentScroll) {
    pos += document.documentElement.scrollTop;
  } else {
    pos += this.container.scrollTop;
  }

  this.store.set('pos', pos);

  if (this.setting.useCover) {
    this.cover.classList.add('__xeBottomSheetCover--open');
    if (this.setting.bodyScroll) {
      this.cover.style.top = `${document.body.scrollTop}px`;
    } else if (this.setting.documentScroll) {
      this.cover.style.top = `${document.documentElement.scrollTop}px`;
    } else {
      this.cover.style.top = `${this.container.scrollTop}px`;
    }
  }

  this.wrapper.classList.add('__xeBottomSheetWrapper--open');

  this.wrapper.style.transition = `top ${this.setting.transitionTimeout}ms`;
  this.wrapper.style.top = `${pos}px`;

  if (this.setting.documentScroll) {
    this.wrapper.style.bottom = `${document.documentElement.scrollTop * -1}px`;
  } else if (this.setting.bodyScroll) {
    this.wrapper.style.bottom = `${document.body.scrollTop * -1}px`;
  } else {
    this.wrapper.style.bottom = '';
  }

  if (pass || !this.store.get('isOpen')) {
    this.store.execAction('open');
    if (this.setting.bodyScroll) {
      document.body.style.overflow = 'hidden';
    } else if (this.setting.documentScroll) {
      document.documentElement.style.overflow = 'hidden';
    } else {
      this.container.style.overflow = 'hidden';
    }
    this.emitEvent('xe_bottomsheet::open_done');
  }
};

BottomSheet.prototype.open = function () {
  this.openSheet();
};

BottomSheet.prototype.toggleSheet = function () {
  if (this.store.get('isOpen')) {
    this.closeSheet();
  } else {
    this.openSheet();
  }
};

BottomSheet.prototype.initCustomStyleClass = function () {
  if (!this.options.customStyleClass) {
    this.options.customStyleClass = {};
  }
};

BottomSheet.plugins = mergePlugins([], compatiblePluginAlias(DefaultPlugins.SmoothScrollbarPlugin));

BottomSheet.prototype.emitEvent = function (name) {
  this.originEl.dispatchEvent(new CustomEvent(name, { detail: this }));
};

BottomSheet.prototype.destroy = function () {
  [this.wrapper, this.contents, this.handle, this.cover].forEach((el) => {
    if (el) {
      el.remove();
    }
  });
  this.destroyPlugins();
  BottomSheet.instances.delete(this.originEl.dataset['xeBottomSheetInstanceId']);
  delete this.originEl.dataset['xeBottomSheetInstanceId'];
  this.emitEvent('xe_bottomsheet::destroy');
  return this.originEl;
};

BottomSheet.func = {
  createHandle: function (customClass) {
    const inner = BottomSheet.utils.createElement('div', '__xeBottomSheetHandle-inner');
    const classList = BottomSheet.utils.generateCustomClassList('__xeBottomSheetHandle', customClass);
    const outer = BottomSheet.utils.createElement('div', classList);
    outer.appendChild(inner);
    return outer;
  },
  createWrapper: function (isDiffContainerBody, customClass) {
    const classList = BottomSheet.utils.generateCustomClassList(
      `__xeBottomSheetWrapper${isDiffContainerBody ? ' __xeBottomSheetWrapper--absolute' : ''}`,
      customClass
    );
    return BottomSheet.utils.createElement('div', classList);
  },
  createContents: function (customClass) {
    const classList = BottomSheet.utils.generateCustomClassList('__xeBottomSheetContents', customClass);
    return BottomSheet.utils.createElement('div', classList);
  },
  createCover: function (isDiffContainerBody, customClass) {
    const classList = BottomSheet.utils.generateCustomClassList(
      `__xeBottomSheetCover${isDiffContainerBody ? ' __xeBottomSheetCover--absolute' : ''}`,
      customClass
    );
    return BottomSheet.utils.createElement('div', classList);
  },
  getOriginEl: function (qs) {
    let el = null;

    if (typeof qs === 'string') {
      el = window.document.querySelector(qs);
    } else if (qs instanceof HTMLElement) {
      el = qs;
    } else {
      throw 'Type Error.';
    }
    if (!el) throw 'ERROR';
    return el;
  },
};

BottomSheet.utils = {
  createElement: function (elName, classList) {
    const el = document.createElement(elName);
    if (classList !== undefined) {
      if (Array.isArray(classList)) {
        el.classList.add(...classList);
      } else if (typeof classList === 'string') {
        el.classList.add(...classList.split(' '));
      }
    }
    return el;
  },
  setValue: function (object, attr, value) {
    return object[attr] !== undefined ? object[attr] : value;
  },
  generateCustomClassList: function (defaultClass, customClass) {
    let classList = defaultClass.split(' ');
    if (customClass !== undefined) {
      if (Array.isArray(customClass)) {
        classList = classList.concat(customClass);
      } else if (typeof customClass === 'string') {
        classList.push(...customClass.split(' '));
      }
    }
    return classList;
  },
  compatiblePluginAlias,
  mergePlugins,
};

BottomSheet.instances = new Map();

export default BottomSheet;
